'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SHOW_EVENTS = {
    hover: 'mouseenter',
    focus: 'focus'
};

var HIDE_EVENTS = {
    hover: 'mouseleave',
    focus: 'blur'
};

/**
 * Tooltip
 *
 * @example
 *
 * // Showing on hover (default)
 * <Tooltip content='my tooltip' arrowPosition='left' />
 *
 * // Showing on focus (default)
 * <input id='some-input' />
 * <Tooltip
 *      content='my tooltip'
 *      arrowPosition='left'
 *      trigger='focus'
 *      lockToElement='#some-input'
 *  />
 */
var Tooltip = _react2['default'].createClass({
    displayName: 'Tooltip',


    propTypes: {
        'content': _react2['default'].PropTypes.string.isRequired,
        'text': _react2['default'].PropTypes.string,
        'arrowPosition': _react2['default'].PropTypes.string,
        'isToggled': _react2['default'].PropTypes.bool,
        'isToggleable': _react2['default'].PropTypes.bool, // If false, tooltip will always be permanently displayed
        'classes': _react2['default'].PropTypes.string,
        'cta': _react2['default'].PropTypes.object,
        'lockToElement': _react2['default'].PropTypes.string, // Optional element to lock to

        /**
         * DEPRECATED
         *
         * To change how the tooltip is toggled, use the `trigger` prop below.
         */
        'toggleOn': _react2['default'].PropTypes.string, // Events to toggle on (change/blur/etc) if using the above
        'contentStyle': _react2['default'].PropTypes.object, // Additional styles for tooltip content
        'minWidth': _react2['default'].PropTypes.string,

        /**
         * Sets the appropriate show/hide listeners on the trigger element.  The
         * default is hover.
         *
         *  - `hover` will show the tooltip on mouseover and hide on mouseleave
         *  - `focus` should be used for input elements.  The tooltip will be
         *  shown on focus and hidden on blur.
         */
        'trigger': _react2['default'].PropTypes.oneOf(['hover', 'focus'])
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'text': '?',
            'arrowPosition': 'bottom',
            'isToggled': false,
            'isToggleable': true,
            'lockToElement': null,
            'trigger': 'hover'
        };
    },
    getInitialState: function getInitialState() {
        return {
            'toggled': this.props.isToggled,
            'isToggleable': this.props.isToggleable
        };
    },

    // TODO: refactor the jQuery out of this
    componentDidMount: function componentDidMount() {
        var root = $(_reactDom2['default'].findDOMNode(this));

        if (this.state.isToggleable && !this.props.lockToElement) {
            this.bindToggleEvents('.m-tooltip--text', root);
        } else if (this.state.isToggleable) {
            // Using an element to lock to
            this.bindToggleEvents(this.props.lockToElement);
        }
        this.adjustTooltipPosition();
    },
    componentWillUnmount: function componentWillUnmount() {
        if (typeof this.unBindToggleEvents === 'function') {
            this.unBindToggleEvents();
        }
    },
    bindToggleEvents: function bindToggleEvents() {
        var _this = this;

        var $toggler = $.apply(undefined, arguments);

        // Kept for legacy reasons
        if (this.props.toggleOn) {
            $toggler.bind(this.props.toggleOn, this.toggleTip);

            this.unbindToggleEvents = function () {
                return $toggler.unbind(_this.props.toggleOn, _this.toggleTip);
            };
        } else {
            var showEvent = this.getShowEvent();
            var hideEvent = this.getHideEvent();

            $toggler.bind(showEvent, this.show);
            $toggler.bind(hideEvent, this.hide);

            this.unbindToggleEvents = function () {
                $toggler.unbind(showEvent, _this.show);
                $toggler.unbind(hideEvent, _this.hide);
            };
        }
    },
    getShowEvent: function getShowEvent() {
        return SHOW_EVENTS[this.props.trigger] || SHOW_EVENTS.hover;
    },
    getHideEvent: function getHideEvent() {
        return HIDE_EVENTS[this.props.trigger] || HIDE_EVENTS.hover;
    },
    show: function show() {
        this.setState({
            toggled: true
        }, this.adjustTooltipPosition);
    },
    hide: function hide() {
        this.setState({
            toggled: false
        }, this.adjustTooltipPosition);
    },
    adjustTooltipPosition: function adjustTooltipPosition() {

        var root = $(_reactDom2['default'].findDOMNode(this));
        var parent = root.parent();
        var isVisible = parent.css('display') !== 'none';
        var tooltipBubbleEl;
        var newTop;
        var newLeft;

        if (!isVisible) {
            // Display the tooltip container so we can correctly size it
            parent.show();
        }

        // Adjust vertical positioning if the tooltip is toggled on
        if (this.state.toggled && !this.props.lockToElement) {
            if ($.inArray(this.props.arrowPosition, ['left', 'right']) >= 0) {
                tooltipBubbleEl = $('.m-tooltip--bubble', root);
                tooltipBubbleEl.css({ 'min-width': this.props.minWidth });
                var currentTop = tooltipBubbleEl.offset().top;
                var offsetParentTop = tooltipBubbleEl.offsetParent().offset().top;
                if (offsetParentTop === 0) {
                    newTop = currentTop - tooltipBubbleEl.height() / 2 + 7;
                    tooltipBubbleEl.css('top', newTop);
                } else {
                    var tooltipTextEl = $('.m-tooltip--text', root);
                    var tooltipTextCenter = tooltipTextEl.offset().top + tooltipTextEl.height() / 2;
                    var vertAdjustment = tooltipTextCenter - (currentTop + tooltipBubbleEl.height() / 2);
                    newTop = currentTop - offsetParentTop + vertAdjustment;
                    tooltipBubbleEl.css('top', newTop);
                }
            }
        } else if (this.state.toggled && this.props.lockToElement) {

            // height of box - offset of element
            var lockedElNode = $(this.props.lockToElement);
            var lockedElPosition = lockedElNode.position();
            var lockedElWidth = lockedElNode.outerWidth();
            var lockedElHeight = lockedElNode.innerHeight();
            tooltipBubbleEl = $('.m-tooltip--bubble', root);

            // Currently only used for left arrow positioning vs an element
            if (this.props.arrowPosition == 'left') {
                newLeft = lockedElPosition.left + lockedElWidth;
                tooltipBubbleEl.css({ 'left': newLeft });
                tooltipBubbleEl.css({ 'min-width': this.props.minWidth });
                // Set top value after setting left to account for the new width of the
                // tooltip bubble, since it's auto-width. This puts the vertical center in
                // the correct location
                var lockedElVertMiddle = lockedElPosition.top + lockedElHeight / 2;
                newTop = lockedElVertMiddle - tooltipBubbleEl.innerHeight() / 2;
                tooltipBubbleEl.css({ 'top': newTop });
            } else if (this.props.arrowPosition == 'bottom') {
                newLeft = Math.abs(lockedElPosition.left + lockedElWidth / 2 - tooltipBubbleEl.outerWidth() / 2);
                tooltipBubbleEl.css({ 'left': newLeft });
                newTop = lockedElPosition.top - tooltipBubbleEl.height() - 10;
                tooltipBubbleEl.css({ 'top': newTop });
            }
        }

        if (!isVisible) {
            parent.hide();
        }
    },


    /*
    * Function to toggle tooltip. If using custom events, you can attach a value payload  - 'show' will show the tooltip, anything else will hide
    * This is useful in implementing more complex display logic.
    */

    toggleTip: function toggleTip(e) {

        // Using custom event payload
        if (e && e.value) {
            this.setState({
                'toggled': e.value === 'show'
            });
            // Every other case
        } else {
            this.setState({
                'toggled': !this.state.toggled
            });
        }

        this.adjustTooltipPosition();
    },
    render: function render() {

        var classes = 'm-tooltip';
        if (this.props.classes) {
            classes += ' ' + this.props.classes;
        }

        var cta;
        var ctaClass;
        if (this.props.cta) {
            ctaClass = 'm-tooltip--bubble--content--cta ' + (this.props.cta['class'] || '');
            cta = _react2['default'].createElement(
                'a',
                { href: this.props.cta.url, className: ctaClass },
                this.props.cta.text
            );
        }

        var bubble;
        if (!this.state.isToggleable || this.state.isToggleable && this.state.toggled) {
            bubble = _react2['default'].createElement(
                'span',
                { className: 'm-tooltip--bubble ' + this.props.arrowPosition },
                _react2['default'].createElement('span', { className: 'm-tooltip--bubble--arrow left' }),
                _react2['default'].createElement('span', { className: 'm-tooltip--bubble--arrow top' }),
                _react2['default'].createElement(
                    'span',
                    { className: 'm-tooltip--bubble--content' },
                    this.props.content,
                    ' ',
                    cta
                ),
                _react2['default'].createElement('span', { className: 'm-tooltip--bubble--arrow right' }),
                _react2['default'].createElement('span', { className: 'm-tooltip--bubble--arrow bottom' })
            );
        }

        var renderText = this.props.lockToElement ? '' : this.props.text;
        return _react2['default'].createElement(
            'span',
            { className: classes },
            _react2['default'].createElement(
                'span',
                { className: 'm-tooltip--text' },
                renderText
            ),
            bubble
        );
    }
});

module.exports = Tooltip;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/tooltip.jsx
 ** module id = 727
 ** module chunks = 0 1
 **/